export default __webpack_public_path__ + "static/media/ep-inside.519b22f4.jpg";